import {
  apiGetSchoolTeam,
  apiDeleteTeacher,
  apiPromoteTeacher,
  apiDemoteTeacher,
  apiAddTeacher,
  apiApprovePendingTeacher,
  apiDeclinePendingTeacher,
  apiResendInvitation,
  apiGetGroupSubCheckoutUrl,
  apiAddGroupSubToUser,
  apiRemoveGroupSubFromUser
} from '../../common/api/school'

const fetchSchoolTeam = schoolId => ({
  requestPrefix: 'SCHOOL_TEAM:FETCH',
  params: { schoolId },
  request: () => apiGetSchoolTeam(schoolId)
})

const deleteTeacher = (schoolId, teacherId) => ({
  requestPrefix: 'SCHOOL_TEAM:DELETE',
  params: { schoolId, teacherId },
  request: () => apiDeleteTeacher(schoolId, teacherId)
})

const promoteTeacher = teacherId => ({
  requestPrefix: 'SCHOOL_TEAM:PROMOTE',
  params: { teacherId },
  request: () => apiPromoteTeacher(teacherId)
})

const demoteTeacher = teacherId => ({
  requestPrefix: 'SCHOOL_TEAM:DEMOTE',
  params: { teacherId },
  request: () => apiDemoteTeacher(teacherId)
})

const addTeacher = (schoolId, teacher) => ({
  requestPrefix: 'SCHOOL_TEAM:ADD',
  params: { teacher },
  request: () => apiAddTeacher(schoolId, teacher.email)
})

const approveTeacher = teacher => ({
  requestPrefix: 'SCHOOL_TEAM:APPROVE',
  params: { teacher },
  request: () => apiApprovePendingTeacher(teacher.id)
})

const disapproveTeacher = teacherId => ({
  requestPrefix: 'SCHOOL_TEAM:DISAPPROVE',
  params: { teacherId },
  request: () => apiDeclinePendingTeacher(teacherId)
})

const resendInvitation = teacherId => ({
  requestPrefix: 'SCHOOL_TEAM:RESEND_INVITATION',
  request: () => apiResendInvitation(teacherId)
})

const getGroupSubCheckoutUrl = groupSubId => ({
  requestPrefix: 'SCHOOL_TEAM:GET_CHECKOUT_LINK',
  request: () => apiGetGroupSubCheckoutUrl(groupSubId)
})

const addGroupSub = (groupSubId, userId) => ({
  requestPrefix: 'SCHOOL_TEAM:ADD_GROUP_SUB',
  request: () => apiAddGroupSubToUser(groupSubId, userId)
})

const removeGroupSub = (groupSubId, addonId) => ({
  requestPrefix: 'SCHOOL_TEAM:REMOVE_GROUP_SUB',
  request: () => apiRemoveGroupSubFromUser(groupSubId, addonId)
})

export {
  fetchSchoolTeam,
  deleteTeacher,
  promoteTeacher,
  demoteTeacher,
  addTeacher,
  approveTeacher,
  disapproveTeacher,
  resendInvitation,
  getGroupSubCheckoutUrl,
  addGroupSub,
  removeGroupSub
}
